



















import Vue, { PropOptions } from 'vue';

export type VideoWithText = Blok & {
  title: string;
  subtitle: string;
  video: Blok[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<VideoWithText>,
  },
});
